import { FileText } from 'lucide-react';
import React from 'react';

import { SingleModuleAuditPage } from '@/features/imports/SingleModuleAuditPage';

export const AuditVisaImportsPage = (): React.JSX.Element => (
  <SingleModuleAuditPage
    config={{
      moduleKey: 'visa',
      titlePlural: 'visas',
      routePrefix: 'visas',
      listPath: '/visas',
      ListIcon: FileText,
    }}
  />
);
